<template>
  <a :href="searchUrl" @click="searchThisCondition" class="searchConditionCard">
    <ul>
      <li v-for="(tag, i) in currentConditionsTag" :key="i">
        {{ tag }}
      </li>
    </ul>

    <div v-if="canDelete" class="searchConditionCard_btn">
      <Button
        label="削除"
        :handleClick="
          (ev) => {
            deleteThisCondition(seachData.id, ev)
          }
        "
        sizeS
      />
    </div>
  </a>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { axiosSetting } from '@/utils/axiosSetting'
import Button from '@/components/elements/Button.vue'
import { useSearchCondition } from '@/utils/useSearchCondition'

export default defineComponent({
  components: {
    Button
  },

  props: {
    type: {
      type: String as PropType<'hospital' | 'latter'>,
      default: 'hospital'
    },
    seachData: {
      type: Object,
      required: true
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      require: false
    }
  },

  setup(props, { emit }) {
    const router = useRouter()
    const store = useStore()

    const {
      getSearchConditionFromQuery,
      getSearchConditionTag
    } = useSearchCondition()

    const currentConditions = computed(() =>
      getSearchConditionFromQuery(props.seachData.search_history, props.type)
    )

    const currentConditionsTag = computed(() =>
      getSearchConditionTag(currentConditions.value)
    )

    const searchUrl = computed(() => {
      let path = `/search/${props.type}/list`

      const conditions = props.seachData.search_history
      Object.keys(conditions).forEach((key) => {
        if (key === 'prefectures') path += `/pr_${conditions[key].join('+')}`

        if (key === 'program_subjects')
          path += `/sj_${conditions[key].join('+')}`

        if (key === 'hospital_class') path += `/cl_${conditions[key].join('+')}`

        if (key === 'feature_tag') path += `/pk_${conditions[key].join('+')}`

        if (key === 'designated_hospital')
          path += `/dh_${conditions[key].join('+')}`

        if (key === 'discerning_conditions')
          path += `/kw_${conditions[key].join('+')}`

        if (key === 'bonus') path += `/rb_1`

        if (key === 'overtime_hours_mavg') path += `/ro_1`

        if (key === 'house') path += `/rh_1`

        if (key === 'j_graduating_school') path += `/gs_1`

        if (key === 'bed_num_lo') {
          const reg = /bn_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'bn_' + conditions[key] + '-$1')
          } else {
            path += `/bn_${conditions[key]}-`
          }
        }

        if (key === 'bed_num_hi') {
          const reg = /bn_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'bn_$1-' + conditions[key])
          } else {
            path += `/bn_-${conditions[key]}`
          }
        }

        if (key === 'department_bed_num_lo') {
          const reg = /sb_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'sb_' + conditions[key] + '-$1')
          } else {
            path += `/sb_${conditions[key]}-`
          }
        }

        if (key === 'department_bed_num_hi') {
          const reg = /sb_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'sb_$1-' + conditions[key])
          } else {
            path += `/sb_-${conditions[key]}`
          }
        }

        if (key === 'resident_num_lo') {
          const reg = /mi_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'mi_' + conditions[key] + '-$1')
          } else {
            path += `/mi_${conditions[key]}-`
          }
        }

        if (key === 'resident_num_hi') {
          const reg = /mi_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'mi_$1-' + conditions[key])
          } else {
            path += `/mi_-${conditions[key]}`
          }
        }

        if (key === 'instructor_num_lo') {
          const reg = /si_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'si_' + conditions[key] + '-$1')
          } else {
            path += `/si_${conditions[key]}-`
          }
        }

        if (key === 'instructor_num_hi') {
          const reg = /si_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'si_$1-' + conditions[key])
          } else {
            path += `/si_-${conditions[key]}`
          }
        }

        if (key === 'doctor_num_lo') {
          const reg = /dn_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'dn_' + conditions[key] + '-$1')
          } else {
            path += `/dn_${conditions[key]}-`
          }
        }

        if (key === 'doctor_num_hi') {
          const reg = /dn_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'dn_$1-' + conditions[key])
          } else {
            path += `/dn_-${conditions[key]}`
          }
        }

        if (key === 'positions_num_lo' || key === 'recruitment_num_lo') {
          const reg = /pn_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'pn_' + conditions[key] + '-$1')
          } else {
            path += `/pn_${conditions[key]}-`
          }
        }

        if (key === 'positions_num_hi' || key === 'recruitment_num_hi') {
          const reg = /pn_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'pn_$1-' + conditions[key])
          } else {
            path += `/pn_-${conditions[key]}`
          }
        }

        if (key === 'income_lo' || key === 's_salary3_num_lo') {
          const reg = /ai_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'ai_' + conditions[key] + '-$1')
          } else {
            path += `/ai_${conditions[key]}-`
          }
        }

        if (key === 'income_hi' || key === 's_salary3_num_hi') {
          const reg = /ai_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'ai_$1-' + conditions[key])
          } else {
            path += `/ai_-${conditions[key]}`
          }
        }

        if (key === 'shifts_num_lo' || key === 's_shifts3_num_lo') {
          const reg = /sn_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'sn_' + conditions[key] + '-$1')
          } else {
            path += `/sn_${conditions[key]}-`
          }
        }

        if (key === 'shifts_num_hi' || key === 's_shifts3_num_hi') {
          const reg = /sn_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'sn_$1-' + conditions[key])
          } else {
            path += `/sn_-${conditions[key]}`
          }
        }

        if (key === 'free_word') path += `/fw_${conditions[key]}`
      })

      return path
    })

    // この条件で検索する
    const searchThisCondition = (e: any) => {
      if (e.ctrlKey || e.metaKey) return true
      e.preventDefault()

      if (store.state.visibleSearchModal) store.dispatch('closeSearchModal')

      router.push(searchUrl.value)
    }

    // 削除する
    const deleteThisCondition = (id: number, ev: any) => {
      ev.preventDefault()
      ev.stopPropagation()

      const deleteCondition = axiosSetting('app', 'action')

      deleteCondition
        .post('/api/v1/search_history_dell', { search_history_id: id })
        .then((res) => {
          emit('delete-condition', {
            index: props.index,
            type: props.type
          })
        })
    }

    return {
      currentConditions,
      currentConditionsTag,
      searchUrl,
      searchThisCondition,
      deleteThisCondition
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.searchConditionCard {
  display: block;
  width: 100%;
  padding: 6px 0 16px 16px;
  background-color: var.$color-white;
  border: 1px solid var.$color-border-gray;
  border-radius: 10px;
  box-shadow: 0 6px 9px rgba(0, 0, 0, 0.08);
  font-size: 1.4rem;
  color: inherit;
  position: relative;

  &:before {
    content: '';
    display: block;
    width: 20px;
    height: 100%;
    background-color: var.$color-main;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: 0 10px 10px 0;
  }

  &:after {
    position: absolute;
    right: 7px;
    top: 50%;
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg);
    margin-top: -5px;
  }

  & + & {
    margin-top: 16px;
  }

  > ul {
    display: flex;
    flex-wrap: wrap;
    padding-right: 36px;

    > li {
      font-size: 1.3rem;
      font-weight: 500;
      background-color: #fff;
      color: #666;
      padding: 8px 10px;
      line-height: 1;
      white-space: nowrap;
      border: 1px solid #e4e4e4;
      border-radius: 2px;
      margin: 10px 5px 0 0;
    }
  }

  &_btn {
    margin-top: 16px;
    margin-right: 36px;
  }
}
</style>
